import {
  STATION_1,
  STATION_2,
  STATION_3,
  STATION_4,
  WARM_UP,
} from 'utils/constants/stations';
import {
  verifyStationContent,
  verifyStationsContent,
} from 'utils/station-verify';

import { createSelector } from 'reselect';
import verifyLocationStationContent from 'utils/location-stations-verify';

export const getVideoConsoleForm = (state) => state.form['video-console'];

export const getVideoConsoleFormTimes = createSelector(
  getVideoConsoleForm,
  ({ values }) => values?.times
);

export const getVideoConsoleFormStations = createSelector(
  getVideoConsoleForm,
  ({ values }) => values?.stations
);

export const isVideoConsoleFormWarmUpComplete = createSelector(
  getVideoConsoleForm,
  ({ values }) => verifyStationContent(values?.stations[WARM_UP])
);
export const isVideoConsoleFormStation1Complete = createSelector(
  getVideoConsoleForm,
  ({ values }) => verifyStationContent(values?.stations[STATION_1])
);
export const isVideoConsoleFormStation2Complete = createSelector(
  getVideoConsoleForm,
  ({ values }) => verifyStationContent(values?.stations[STATION_2])
);
export const isVideoConsoleFormStation3Complete = createSelector(
  getVideoConsoleForm,
  ({ values }) => verifyStationContent(values?.stations[STATION_3])
);
export const isVideoConsoleFormStation4Complete = createSelector(
  getVideoConsoleForm,
  ({ values }) => verifyStationContent(values?.stations[STATION_4])
);

export const isVideoConsoleFormLocationStationComplete = createSelector(
  getVideoConsoleForm,
  ({ values }) => {
    return verifyLocationStationContent(values);
  }
);

export const areVideoConsoleFormStationsComplete = createSelector(
  getVideoConsoleForm,
  ({ values }) => {
    return verifyStationsContent(values);
  }
);
